<script context="module"></script>

<script>import Blocks from "../../components/blocks/blocks.svelte";
import "../../components/dynamic-div.svelte";
import DynamicRenderer from "../../components/dynamic-renderer/dynamic-renderer.svelte";
import InlinedStyles from "../../components/inlined-styles.svelte";
import { getSizesForBreakpoints } from "../../constants/device-sizes";
import { TARGET } from "../../constants/target";
import "../../functions/deopt";
import { getClassPropName } from "../../functions/get-class-prop-name";
import { mapStyleObjToStrIfNeeded } from "../../functions/get-style";
import { getColumnsClass } from "./helpers";
export let space = undefined;
export let columns = undefined;
export let stackColumnsAt = undefined;
export let builderLinkComponent = undefined;
export let reverseColumnsWhenStacked = undefined;
export let builderContext;
export let builderBlock;
export let builderComponents;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
function getTagName(column) {
    return column.link ? builderLinkComponent || "a" : "div";
}
function getWidth(index) {
    return cols[index]?.width || 100 / cols.length;
}
function getColumnCssWidth(index) {
    const width = getWidth(index);
    const subtractWidth = gutterSize * (cols.length - 1) * (width / 100);
    return `calc(${width}% - ${subtractWidth}px)`;
}
function getTabletStyle({ stackedStyle, desktopStyle, }) {
    return stackAt === "tablet" ? stackedStyle : desktopStyle;
}
function getMobileStyle({ stackedStyle, desktopStyle, }) {
    return stackAt === "never" ? desktopStyle : stackedStyle;
}
function columnsCssVars() {
    return {
        "--flex-dir": flexDir,
        "--flex-dir-tablet": getTabletStyle({
            stackedStyle: flexDir,
            desktopStyle: "row",
        }),
    };
}
function columnCssVars(index) {
    const gutter = index === 0 ? 0 : gutterSize;
    const width = getColumnCssWidth(index);
    const gutterPixels = `${gutter}px`;
    const mobileWidth = "100%";
    const mobileMarginLeft = 0;
    const marginLeftKey = "margin-left";
    const sharedStyles = {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
    };
    return {
        ...sharedStyles,
        width,
        [marginLeftKey]: gutterPixels,
        "--column-width-mobile": getMobileStyle({
            stackedStyle: mobileWidth,
            desktopStyle: width,
        }),
        "--column-margin-left-mobile": getMobileStyle({
            stackedStyle: mobileMarginLeft,
            desktopStyle: gutterPixels,
        }),
        "--column-width-tablet": getTabletStyle({
            stackedStyle: mobileWidth,
            desktopStyle: width,
        }),
        "--column-margin-left-tablet": getTabletStyle({
            stackedStyle: mobileMarginLeft,
            desktopStyle: gutterPixels,
        }),
    };
}
function getWidthForBreakpointSize(size) {
    const breakpointSizes = getSizesForBreakpoints($builderContext.content?.meta?.breakpoints || {});
    return breakpointSizes[size].max;
}
function columnsStyles() {
    return `
        @media (max-width: ${getWidthForBreakpointSize("medium")}px) {
          .${builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          .${builderBlock.id}-breakpoints > .builder-column {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${getWidthForBreakpointSize("small")}px) {
          .${builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          .${builderBlock.id}-breakpoints > .builder-column {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
}
function getAttributes(column, index) {
    return {
        ...{},
        ...(column.link
            ? {
                href: column.link,
            }
            : {}),
        [getClassPropName()]: "builder-column",
        style: mapStyleObjToStrIfNeeded(columnCssVars(index)),
    };
}
let gutterSize = typeof space === "number" ? space || 0 : 20;
let cols = columns || [];
let stackAt = stackColumnsAt || "tablet";
let flexDir = stackColumnsAt === "never"
    ? "row"
    : reverseColumnsWhenStacked
        ? "column-reverse"
        : "column";
</script>

<div
  style={stringifyStyles(columnsCssVars())}
  class={getColumnsClass(builderBlock?.id) + " div"}
  {...{}}
>
  {#if TARGET !== "reactNative"}
    <InlinedStyles
      id="builderio-columns"
      styles={columnsStyles()}
      nonce={$builderContext.nonce}
    />
  {/if}
  {#each columns as column, index (index)}
    <DynamicRenderer
      TagName={getTagName(column)}
      actionAttributes={{}}
      attributes={getAttributes(column, index)}
      ><Blocks
        path={`component.options.columns.${index}.blocks`}
        parent={builderBlock.id}
        styleProp={{
          flexGrow: "1",
        }}
        context={builderContext}
        registeredComponents={builderComponents}
        linkComponent={builderLinkComponent}
        blocks={column.blocks}
      /></DynamicRenderer
    >
  {/each}
</div>

<style>
  .div {
    display: flex;
    line-height: normal;
  }
</style>